import { render, staticRenderFns } from "./FolderStructureAttributes.vue?vue&type=template&id=1c11dd0c&scoped=true&"
import script from "./FolderStructureAttributes.vue?vue&type=script&lang=js&"
export * from "./FolderStructureAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c11dd0c",
  null
  
)

export default component.exports